var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-copy",on:{"click":_vm.copyToClipboard}},[_vm._t("default"),_c('i',{staticClass:"el-icon-copy-document el-copy-hover"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }